import { Box, Container, Typography, Divider, Stack, IconButton } from '@mui/material'
import { Link } from 'react-router-dom'
import {
  IconBrandLinkedin, IconBrandFacebook, IconBrandInstagram, IconLeaf,
} from '@tabler/icons-react'
import { tokens } from '@/theme'
import { alpha } from '@mui/material'

const LINKS = {
  Platform: [
    { label: 'Home',          to: '/'               },
    { label: 'For GSAs',      to: '/for-gsas'       },
    { label: 'News & Updates', to: '/news'          },
    { label: 'GSA Resources', to: '/gsa-california' },
  ],
  Resources: [
    { label: 'SGMA Overview',     to: '/gsa-california' },
    { label: 'Groundwater Basics', to: '/news' },
    { label: 'Irrigation Data',    to: '/news' },
  ],
}

const SOCIAL = [
  { icon: <IconBrandLinkedin size={18} />, href: 'https://linkedin.com', label: 'LinkedIn'  },
  { icon: <IconBrandFacebook size={18} />, href: 'https://facebook.com', label: 'Facebook'  },
  { icon: <IconBrandInstagram size={18} />, href: 'https://instagram.com', label: 'Instagram'},
]

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{ background: tokens.green['900'], color: 'rgba(255,255,255,0.75)', mt: 'auto' }}
    >
      <Container maxWidth="lg" sx={{ py: { xs: 5, md: 7 } }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '2fr 1fr 1fr' },
            gap: 5,
            mb: 5,
          }}
        >
          {/* Brand column */}
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1.5 }}>
              <IconLeaf size={20} style={{ color: tokens.green[300] }} />
              <Typography
                sx={{
                  fontFamily: '"Poppins", system-ui, sans-serif',
                  fontWeight: 900,
                  fontSize: '1.25rem',
                  letterSpacing: '-0.02em',
                  color: '#fff',
                }}
              >
                Agro<Box component="span" sx={{ color: tokens.blue.light }}>Lense</Box>
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ opacity: 0.7, maxWidth: 280, lineHeight: 1.65 }}>
              Agriculture and water data aggregation and reporting for growers, GSAs, consultants, and irrigation districts.
            </Typography>
            <Stack direction="row" spacing={0.5} sx={{ mt: 2.5 }}>
              {SOCIAL.map(({ icon, href, label }) => (
                <IconButton
                  key={label}
                  component="a"
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  size="small"
                  sx={{
                    color: 'rgba(255,255,255,0.5)',
                    border: `1px solid ${alpha('#fff', 0.12)}`,
                    '&:hover': { color: '#fff', borderColor: alpha('#fff', 0.35) },
                    transition: 'all 0.2s',
                  }}
                >
                  {icon}
                </IconButton>
              ))}
            </Stack>
          </Box>

          {/* Link columns */}
          {Object.entries(LINKS).map(([heading, links]) => (
            <Box key={heading}>
              <Typography
                variant="overline"
                sx={{ color: 'rgba(255,255,255,0.4)', display: 'block', mb: 1.5 }}
              >
                {heading}
              </Typography>
              <Stack spacing={1}>
                {links.map(({ label, to }) => (
                  <Box
                    key={label}
                    component={Link}
                    to={to}
                    sx={{
                      fontSize: '0.875rem',
                      color: 'rgba(255,255,255,0.65)',
                      textDecoration: 'none',
                      transition: 'color 0.2s',
                      '&:hover': { color: '#fff' },
                    }}
                  >
                    {label}
                  </Box>
                ))}
              </Stack>
            </Box>
          ))}
        </Box>

        <Divider sx={{ borderColor: alpha('#fff', 0.1), mb: 3 }} />

        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="caption" sx={{ opacity: 0.45 }}>
            © {new Date().getFullYear()} AgroLense · Agriculture & water data reporting
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.35 }}>
            Not legal, engineering, or regulatory advice. Confirm details with official sources.
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}
